import unomit from '../../../Services/unomit'

export default (projectId) => (dispatch) => {

  dispatch(unomit(projectId))

}
